import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { listStoreCategories } from "../../Redux/Actions/CategoryActions";
import { listFeaturedProducts } from "../../Redux/Actions/ProductActions";
import "../styles/categories-bar.css";

const formatCategoryName = (text = "") => {
  return text.toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
};

const CategoriesBar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;

  const navRef = useRef(null);
  const [isCentered, setIsCentered] = useState(false);

  const categoryStoreList = useSelector((state) => state.categoryStoreList);
  const { categories = [] } = categoryStoreList || {};

  const productFeaturedList = useSelector((state) => state.productFeaturedList);
  const { products = [] } = productFeaturedList || {};

  useEffect(() => {
    dispatch(listStoreCategories());
    dispatch(listFeaturedProducts(12));
  }, [dispatch]);

  useEffect(() => {
    const checkCenter = () => {
      const nav = navRef.current;
      if (!nav) return;

      setIsCentered(nav.scrollWidth <= nav.clientWidth);
    };

    checkCenter();
    window.addEventListener("resize", checkCenter);

    return () => window.removeEventListener("resize", checkCenter);
  }, [categories, products]);

  const hasFeaturedProducts = Array.isArray(products) && products.length > 0;

  const isProducts = currentPath === "/" || currentPath.startsWith("/search");
  const isFeatured =
    currentPath === "/destacados" || currentPath.startsWith("/destacados/");
  const isCategoriesPage = currentPath === "/categorias";

  return (
    <div className="categories-bar">
      <div className="site-shell">
        <div className="site-shell-inner">
          <div className="categories-scroll-wrapper">
            <nav
              ref={navRef}
              className={`categories-nav ${isCentered ? "centered" : ""}`}
            >
              <Link
                to="/"
                className={"category-link" + (isProducts ? " active" : "")}
              >
                Inicio
              </Link>

              {hasFeaturedProducts && (
                <Link
                  to="/destacados"
                  className={"category-link" + (isFeatured ? " active" : "")}
                >
                  Destacados
                </Link>
              )}

              <Link
                to="/categorias"
                className={
                  "category-link" + (isCategoriesPage ? " active" : "")
                }
              >
                Categorías
              </Link>

              {categories.map((cat) => {
                const categoryPath = `/categorias/${cat.slug}`;
                const isActive = currentPath === categoryPath;

                return (
                  <Link
                    key={cat._id}
                    to={categoryPath}
                    className={"category-link" + (isActive ? " active" : "")}
                  >
                    {formatCategoryName(cat.name)}
                  </Link>
                );
              })}
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesBar;